import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=705c8f94&scoped=true&"
import script from "./Collections.vue?vue&type=script&lang=ts&"
export * from "./Collections.vue?vue&type=script&lang=ts&"
import style0 from "./Collections.vue?vue&type=style&index=0&id=705c8f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c8f94",
  null
  
)

export default component.exports